import { render } from "./IconPlayBox.vue?vue&type=template&id=1e15d1a9"
import script from "./IconPlayBox.vue?vue&type=script&lang=js"
export * from "./IconPlayBox.vue?vue&type=script&lang=js"
script.render = render

export default script